/**
 * Download client-side do relatório gerado.
 *
 * Decisão (b) Gap PDF (kickoff §Perguntas): o backend v1 entrega o `document`
 * model (não bytes). O FE renderiza em tela + permite baixar o JSON completo
 * (com hash) e imprimir/salvar como PDF via diálogo do navegador. Assinatura
 * ICP-Brasil fica para a fatia P-4.
 */

import type { GeneratedLgpdReport } from './types';

/** Nome de arquivo determinístico baseado no relatório. */
export function reportFilename(report: GeneratedLgpdReport, ext: string): string {
  const date = report.generatedAt.slice(0, 10);
  return `relatorio-lgpd-${report.reportType}-${date}.${ext}`;
}

/** Serializa o relatório (incl. integridade) como JSON identado. */
export function serializeReportJson(report: GeneratedLgpdReport): string {
  return JSON.stringify(report, null, 2);
}

/** Dispara o download do JSON via blob + anchor (no-op fora do browser). */
export function downloadReportJson(report: GeneratedLgpdReport): void {
  if (typeof document === 'undefined' || typeof URL.createObjectURL !== 'function') return;
  const blob = new Blob([serializeReportJson(report)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = reportFilename(report, 'json');
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
